var map = {
	"./1.svg": "40ed",
	"./10.svg": "61db",
	"./11.svg": "8f57",
	"./12.svg": "ccff",
	"./13.svg": "e048",
	"./14.svg": "7a24",
	"./15.svg": "5920",
	"./16.svg": "7fd6",
	"./17.svg": "addc",
	"./18.svg": "bf56",
	"./19.svg": "e2e7",
	"./2.svg": "4715",
	"./20.svg": "146a",
	"./21.svg": "3cb4",
	"./3.svg": "37b5",
	"./4.svg": "3fa8",
	"./5.svg": "7740",
	"./6.svg": "1441",
	"./7.svg": "3305",
	"./8.svg": "f0b3",
	"./9.svg": "8d3f",
	"./calendar.svg": "6bca",
	"./circle_close.svg": "bc77",
	"./close.svg": "0572",
	"./export.svg": "fd49",
	"./filters.svg": "9cd4",
	"./pagination-arrow.svg": "aaf1",
	"./plus.svg": "6cf9",
	"./rating.svg": "5d1c",
	"./save.svg": "077b",
	"./settings.svg": "e15e",
	"./success.svg": "53ea",
	"./table_sort_arrow.svg": "f705",
	"./trash.svg": "a3e6",
	"./treeview_arrow.svg": "c9f8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5981";